import GameHub from "../assets/projects/GameHub.PNG";
import ImageGallery from "../assets/projects/imageGallery.PNG";
import SoundDesign from "../assets/projects/soundDesign.PNG";
import EasyStream from "../assets/projects/EasyStream.PNG";
import NetflixGpt from "../assets/projects/NetflixPage.JPG";
import shortly from "../assets/projects/shortly.JPG";
import loopstudios from "../assets/projects/loopstudios.JPG";
import simple from "../assets/projects/simplewebsite.JPG";

export const data = [
  {
    id: 1,
    name: "EasyStream",
    image: EasyStream,
    github: "https://github.com/manasakarisiddappa/youtube",
    live: "https://youtube-five-pi.vercel.app/",
  },
  {
    id: 2,
    name: "NetflixGpt",
    image: NetflixGpt,
    github: "https://github.com/manasakarisiddappa/netflix-gpt",
    live: "https://netflix-gpt-one-opal.vercel.app/",
  },
  {
    id: 3,
    name: "ImageGallery",
    image: ImageGallery,
    github: "https://github.com/manasakarisiddappa/FOTOFLIX",
    live: "https://fotoflix.vercel.app/",
  },
  {
    id: 4,
    name: "Shortly",
    image: shortly,
    github: "https://github.com/manasakarisiddappa/shortly",
    live: "https://dapper-swan-c6180a.netlify.app/",
  },
  {
    id: 5,
    name: "Loopstudios",
    image: loopstudios,
    github: "https://github.com/manasakarisiddappa/loopstudios",
    live: "https://sprightly-gnome-4359f2.netlify.app/",
  },
  {
    id: 6,
    name: "SimplePage",
    image: simple,
    github: "https://github.com/manasakarisiddappa/website-project",
    live: "https://precious-creponne-126f42.netlify.app/",
  },
  {
    id: 7,
    name: "GameHub",
    image: GameHub,
    github: "https://github.com/manasakarisiddappa/game-hub",
    live: "https://game-hub-roan-three.vercel.app/",
  },
  {
    id: 8,
    name: "SoundDesign",
    image: SoundDesign,
    github: "https://github.com/manasakarisiddappa/SOUNDDESIGN",
    live: "https://responsivesounddesign.netlify.app/",
  },
];
